import axios from "axios";
import { isEmpty, isEmptyObject } from "./tools";

export const app_Token = (token) => {
  try {
    if (!!token) {
      sessionStorage.setItem("token", JSON.stringify(token));
    } else {
      return JSON.parse(sessionStorage.getItem("token"));
    }
  } catch (error) {
    return "";
  }
};
export const setToken = async (values) => {
  return new Promise((resolve) => {
    var setToken = {
      token: values.token,
      expireUTCTime: values.expireUTCTime,
    };
    app_Token(setToken);
    axios.defaults.headers.common["token"] = setToken.token;
    axios.defaults.headers.common["Authorization"] = "Bearer " + setToken.token;
    resolve();
  });
};
export const setSessionStorage = (name, values) => {
  try {
    return sessionStorage.setItem(name, values);
  } catch (error) {
    return "";
  }
};
export const getSessionStorage = (name) => {
  try {
    return sessionStorage.getItem(name);
  } catch (error) {
    return "";
  }
};
export const checkToken = () => {
  return new Promise((resolve) => {
    let _token = app_Token();
    if (!isEmptyObject(_token)) {
      setToken(_token);
      var pass = _token;
      if (!isEmpty(pass.token) && !isEmpty(pass.expireUTCTime)) {
        var year = parseInt(pass.expireUTCTime.split("T")[0].split("-")[0]),
          month = parseInt(pass.expireUTCTime.split("T")[0].split("-")[1]),
          day = parseInt(pass.expireUTCTime.split("T")[0].split("-")[2]),
          hours = parseInt(
            pass.expireUTCTime.split("T")[1].split(".")[0].split(":")[0],
          ),
          minutes = parseInt(
            pass.expireUTCTime.split("T")[1].split(".")[0].split(":")[1],
          ),
          second = parseInt(
            pass.expireUTCTime.split("T")[1].split(".")[0].split(":")[2],
          );
        var utcDate = new Date(
          Date.UTC(year, month - 1, day, hours, minutes, second),
        );
        var distance = utcDate - new Date();
        if (distance <= 120) {
          resolve(false);
        } else {
          resolve(true);
        }
      } else {
        resolve(false);
      }
    } else {
      resolve(false);
    }
  });
};
